import React from "react";
import type { SocialLink } from "../types/ArtWork";
import { LinkIcon } from "./LinkIcon";
import { useLinkCaption } from "../hooks/useTranslatedArtwork";

function ArtworkLinkButton({
  url,
  label,
  caption,
  compact = false,
}: {
  url: string;
  label: string;
  caption?: string;
  compact?: boolean;
}) {
  const text = useLinkCaption(label, caption);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn-primary inline-flex items-center justify-center gap-2 border-0 ${
        compact ? "!px-4 !py-2 !text-xs" : "!px-5 !py-2.5 !text-xs"
      }`}
    >
      <LinkIcon label={label} className="h-4 w-4 text-white" />
      {text}
    </a>
  );
}

export function ArtworkExternalLinks({
  links,
  compact = false,
  className = "",
}: {
  links?: SocialLink[];
  compact?: boolean;
  className?: string;
}) {
  if (!links?.length) return null;

  return (
    <div className={`flex flex-wrap gap-2.5 ${className}`}>
      {links.map(({ URL, label, caption }) => (
        <ArtworkLinkButton
          key={URL}
          url={URL}
          label={label}
          caption={caption}
          compact={compact}
        />
      ))}
    </div>
  );
}
